import { defineMessages } from 'react-intl'


export default defineMessages({
  details: {
    defaultMessage: 'Details',
    id: 'tcf-consent-row.details',
  },
})
